import { render, staticRenderFns } from "./FollowDepartmentListItemMenu.vue?vue&type=template&id=11971ea6&scoped=true&"
import script from "./FollowDepartmentListItemMenu.vue?vue&type=script&lang=js&"
export * from "./FollowDepartmentListItemMenu.vue?vue&type=script&lang=js&"
import style0 from "./FollowDepartmentListItemMenu.vue?vue&type=style&index=0&id=11971ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11971ea6",
  null
  
)

export default component.exports